import '../page/userManuals.css'
import { Container, Card } from 'react-bootstrap';
import Masonry from 'react-masonry-css'

function UserManualsAPI() {

    const breakpoints = {
        default: 3,
        1100: 2,
        700: 1,
        500: 1
    }

    return (
        <Container>

            <div className="text-center px-3 text-white">
                {/*<h1 className="display-6">RMUTI API SERVICE</h1>*/}
                <h5>
                    <span>ระบบบริการข้อมูล API
                        <br />เข้าใช้งานด้วยบัญชีสมาชิกอินเทอร์เน็ตของมหาวิทยาลัย
                        <br />และรับ Token เพื่อนำไปใช้งานกับระบบ API
                    </span>
                </h5>
                <h3>
                    <p><br /><b>วิธีการใช้งาน</b></p>
                </h3 >
            </div >

            <Masonry
                breakpointCols={breakpoints}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column">

                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title><b>1. เข้าสู่ระบบ</b></Card.Title>
                        <Card.Text className="card-text">เข้าใช้งานผ่านบัญชีสมาชิกอินเทอร์เน็ตของมหาวิทยาลัย</Card.Text>
                        <div className="d-grid gap-2">
                            <a type="button" target="#" rel="noopener noreferrer" href="https://api.rmuti.ac.th/sso/index.php?login&redirect=oauth.php"
                                className="btn btn-primary">
                                <h5>Login</h5>
                            </a>
                        </div>
                    </Card.Body>
                </Card>

                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title><b>2. เลือกบริการและยินยอมให้เข้าถึงข้อมูล</b></Card.Title>
                        <Card.Text>เลือกบริการโดยใส่รหัสบริการผ่าน Parameter 'sv' และใส่ redirect ปลายทาง ผ่าน 'redirect_uri' ทาง url </Card.Text>
                        <Card.Text>
                            ตัวอย่าง <br />
                            <div className='code'>URL?sv=<b>your_service_code</b>&redirect_uri=<b>your_uri</b></div>
                        </Card.Text>
                        <Card.Text>
                            จากนั้นกด <b><i>"ยอมรับ" </i></b>
                            เพื่ออนุญาตให้เข้าถึงข้อมูลตามรายละเอียดที่แสดงบนหน้าจอ หรือ กด <b><i>"ยกเลิก" </i></b> เพื่อจบการทำงาน
                        </Card.Text>
                        <div className="d-grid gap-2">
                            <a type="button" target="#" rel="noopener noreferrer" href="https://api.rmuti.ac.th/sso/oauth" className="btn btn-primary">
                                <h5>User Permission</h5>
                            </a>
                        </div>
                    </Card.Body>
                </Card>

                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title><b>3. ได้รับ Authorization Code</b></Card.Title>
                        <Card.Text>
                            หากทุกอย่างถูกต้อง จะได้รับ Authorization Code ผ่าน Parameter <b>"Code"</b>
                        </Card.Text>
                        <Card.Text>
                            ตัวอย่าง <br />
                            <div className='code'>URL/callback?code=<b>xxxxxxxxxx</b></div>
                        </Card.Text>
                        <Card.Text>ข้อแนะนำ <br />Authorization Code มีอายุ <b><i>สั้นมาก</i></b></Card.Text>
                    </Card.Body>
                </Card>

                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title><b>4. ขอ Token</b></Card.Title>
                        <Card.Text>Link ส่ง <b>Authorization Code </b>เพื่อขอ Token</Card.Text>
                        <Card.Text>ในขั้นตอนนี้ต้องส่ง <b>Client Id</b> และ <b>Client Secret </b>
                            ที่ถูกต้องเข้ามาด้วย</Card.Text>
                        <Card.Text>
                            <div className='code'>https://api.rmuti.ac.th/api/oauth/token</div>
                        </Card.Text>
                        <Card.Text><b>REQUEST</b>
                            <div className='code'>POST</div>
                        </Card.Text>
                        <Card.Text><b>HEADERS</b><br />
                            <div className='code'>Content-Type:application/x-www-form-urlencoded</div>
                        </Card.Text>
                        <Card.Text><b>BODY</b><br />
                            <div className='code'>client_id=???</div>
                            <div className='code'>client_secret=???</div>
                            <div className='code'>grant_type= <b>authorization_code</b></div>
                            <div className='code'>code= [authorized code ที่ได้จากขั้นตอนที่ 3]</div>
                        </Card.Text >
                        <Card.Text><b>RESPONSE</b><br />
                            <div className='code'>&#123;<br />
                                "token_type": "type",<br />
                                "expires_in": 123,<br />
                                "access_token": "acc_token",<br />
                                "refresh_token": "refh_token"<br />
                                &#125;
                            </div ><br />
                        </Card.Text>
                    </Card.Body >
                </Card>

                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title><b>5. ขอ Token ใหม่</b></Card.Title>
                        <Card.Text>Link ส่ง <b>Refresh Token </b>เพื่อขอ Token ใหม่
                        </Card.Text>
                        <Card.Text><div className='code'>https://api.rmuti.ac.th/api/oauth/token</div></Card.Text>
                        <Card.Text><b>REQUEST</b>
                            <div className='code'>POST</div>
                        </Card.Text>
                        <Card.Text><b>HEADERS</b><br />
                            <div className='code'>Content-Type:application/x-www-form-urlencoded</div>
                        </Card.Text>
                        <Card.Text><b>BODY</b><br />
                            <div className='code'>client_id=???</div>
                            <div className='code'>client_secret=???</div>
                            <div className='code'>grant_type= <b>refresh_token</b></div>
                            <div className='code'>refresh_token= [refresh_token ที่ได้จากขั้นตอนที่ 4]</div><br />
                        </Card.Text>
                        <Card.Text><b>RESPONSE</b><br />
                            <div className='code'>&#123;<br />
                                "token_type": "type",<br />
                                "expires_in": 123,<br />
                                "access_token": "acc_token",<br />
                                "refresh_token": "refh_token"<br />
                                &#125;
                            </div ><br />
                        </Card.Text>
                    </Card.Body >
                </Card>
                
                <Card className='my-3'>
                    <Card.Body>
                        <Card.Title className="card-title th-desc"><b>6. เริ่มต้นใช้งานกับ<i>ข้อมูล</i></b></Card.Title>
                        <Card.Text><div className='code'>https://api.rmuti.ac.th/api/v3/[your_personal_info_path]</div></Card.Text>
                        <Card.Text><b>REQUEST</b>
                            <div className='code'>GET</div>
                        </Card.Text>
                        <Card.Text><b>HEADERS</b><br />
                            <div className='code'>Content-Type:application/json</div>
                            <div className='code'>Authorization:Bearer <b>access_token</b></div>
                            <div className='code'>X-Last-Update:&#123;last update timestamp&#125;</div><br />
                        </Card.Text >
                        <Card.Text>หากข้อมูลถูกต้องระบบจะส่งข้อมูลส่วนตัวของผู้ใช้กลับมาในรูปแบบ JSON </Card.Text>
                    </Card.Body >
                </Card>
            </Masonry>

            <div className="text-right text-white">
                <span>Version 3.1
                    <br />Update 18/5/2021
                </span>
            </div >

        </Container >
    )
}

export default UserManualsAPI;